
import {
  defineComponent,
  onMounted,
} from 'vue';

import useEntries from '@/composable/useEntries';

export default defineComponent({
  setup() {
    const {
      entries: domains,
      entriesLoading: domainsLoading,
      fetchEntries: fetchDomains,
    } = useEntries();

    onMounted(async (): Promise<void> => {
      await fetchDomains('/api/v3/domains');
    });

    return {
      domains,
      domainsLoading,
      fetchDomains,
    };
  },
});
